"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const antd_1 = require("antd");
const react_query_1 = require("@tanstack/react-query");
const rte_1 = require("@mantine/rte");
const lodash_1 = require("lodash");
// import Tokens from './Tokens'
const FormLayoutContainer_1 = __importDefault(require("../common/FormLayoutContainer"));
const useMutateWrapper_1 = require("../../hooks/useMutateWrapper");
const emailTemplates_1 = require("../../services/emailTemplates");
const validationMessages_1 = __importDefault(require("../../constants/validationMessages"));
const richTextEditor_1 = __importDefault(require("../../utils/richTextEditor"));
const { Item, useForm } = antd_1.Form;
const { TextArea } = antd_1.Input;
const ManageEmailTemplate = () => {
    const { id: emailTemplatesId } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [manageEmailTemplateForm] = useForm();
    const [editorValue, setEditorValue] = (0, react_1.useState)('');
    const [tokens, setTokens] = (0, react_1.useState)([]);
    const { isLoading, data } = (0, react_query_1.useQuery)(['emailTemplates', emailTemplatesId], (0, emailTemplates_1.getEmailTemplates)({ emailTemplateId: emailTemplatesId }), {
        onError: (err) => {
            const { status, data: { msg } } = err.response;
            switch (status) {
                case 404: return navigate('/applications/404', { state: { comingFrom: 'manage' } });
                case 500: return navigate('/applications/500');
                default: antd_1.message.error(msg);
            }
        },
    });
    (0, react_1.useEffect)(() => {
        if (data) {
            const { tenantName, localeName, htmlBody, tokens: tokensData } = data;
            manageEmailTemplateForm.setFieldsValue(Object.assign(Object.assign({}, data), { tenantId: tenantName, localeCode: localeName }));
            setEditorValue(htmlBody);
            setTokens(tokensData);
        }
    }, [data]);
    const { isLoading: isSubmitting, onFormSubmit } = (0, useMutateWrapper_1.useMutateWrapper)('emailTemplates', emailTemplates_1.updateEmailTemplate, { navigateTo: '/emailTemplates' });
    const handleSubmit = (values) => {
        const { emailTemplatesId: emailTemplateId, tenantId, localeCode } = data;
        onFormSubmit({
            emailTemplatesId: emailTemplateId,
            tenantId,
            localeCode,
            htmlBody: (0, lodash_1.unescape)((0, richTextEditor_1.default)(editorValue)),
            tokens,
            tags: [],
        })(values);
    };
    return ((0, jsx_runtime_1.jsx)(FormLayoutContainer_1.default, Object.assign({ title: data === null || data === void 0 ? void 0 : data.emailTemplateName, loading: isLoading || isSubmitting }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, Object.assign({ scrollToFirstError: true, layout: 'vertical', form: manageEmailTemplateForm, name: 'manage-email-template-form', onFinish: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'tenantId', label: 'Tenant' }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { disabled: true }) })), (0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'localeCode', label: 'Locale' }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { disabled: true }) })), (0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'emailTemplateName', label: 'Name', rules: [{ required: true, message: validationMessages_1.default.required }] }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { showCount: true, maxLength: 500 }) })), (0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'emailTemplateCode', label: 'Code' }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) })), (0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'description', label: 'Description', rules: [{ required: true, message: validationMessages_1.default.required }] }, { children: (0, jsx_runtime_1.jsx)(TextArea, { showCount: true, maxLength: 500, rows: 4 }) })), (0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'subject', label: 'Subject', rules: [{ required: true, message: validationMessages_1.default.required }] }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { showCount: true, maxLength: 500 }) })), data && ((0, jsx_runtime_1.jsx)(Item, Object.assign({ label: 'HTML Body' }, { children: (0, jsx_runtime_1.jsx)(rte_1.RichTextEditor, { controls: [
                            ['bold', 'italic', 'underline', 'strike', 'clean'],
                            ['h1', 'h2', 'h3', 'h4'],
                            ['unorderedList', 'orderedList'],
                            ['alignLeft', 'alignCenter', 'alignRight'],
                            ['link'],
                        ], value: editorValue || data.htmlBody, onChange: setEditorValue }) }))), (0, jsx_runtime_1.jsx)(antd_1.Button, Object.assign({ type: 'primary', htmlType: 'submit' }, { children: "Update & Publish" }))] })) })));
};
exports.default = ManageEmailTemplate;
